import { render } from "./P038.vue?vue&type=template&id=dff99b0e&scoped=true"
import script from "./P038.vue?vue&type=script&lang=js"
export * from "./P038.vue?vue&type=script&lang=js"

import "./P038.vue?vue&type=style&index=0&id=dff99b0e&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dff99b0e"]])

export default __exports__